import type { SVGProps } from "react";
const SvgIconAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M844.35 789.15h-664.7c-18.08 0-34.26-9.35-43.3-25s-9.04-34.35 0-50L468.7 138.49c9.04-15.65 25.23-25 43.3-25 18.08 0 34.26 9.35 43.3 25l332.35 575.65c9.04 15.66 9.04 34.35 0 50s-25.22 25-43.3 25Zm-664.7-50h664.71L512 163.49zm-.14-.01" />
    <circle cx={512} cy={637.65} r={37.5} />
    <path d="M549.5 369.1 537 543.15c-3.13 30.91-46.94 30.77-50 0L474.5 369.1c-1.49-20.71 14.1-38.71 34.81-40.19 22.62-1.82 41.98 17.61 40.19 40.19" />
  </svg>
);
export default SvgIconAlert;
